import {
  isSameProductLink,
  isSameVariantLink,
} from './productLinkMatchers';

export const appendProductLink = (products = [], product) => {
  if (!product?._id) return products;
  if (products.some((link) => isSameProductLink(link, product))) return products;
  return [...products, product];
};

export const appendVariantLink = (productVariants = [], productVariant) => {
  if (!productVariant?.variantId) return productVariants;
  if (productVariants.some((link) => isSameVariantLink(link, productVariant))) {
    return productVariants;
  }
  return [...productVariants, { ...productVariant, numberOfAssets: 1 }];
};

export const applyAssetProductLinks = (state, {
  assetIds = [],
  product = null,
  productVariants = [],
}) => {
  if (!assetIds.length || (!product && !productVariants.length)) return state;

  const assetIdSet = new Set(assetIds.map(String));
  const selectedAffectedCount = assetIds.filter((id) => state.selectedItems.includes(id)).length;

  const items = state.items.map((asset) => {
    if (!assetIdSet.has(String(asset._id))) return asset;

    let products = asset.products || [];
    let variants = asset.productVariants || [];

    if (product) {
      products = appendProductLink(products, product);
    }

    productVariants.forEach((productVariant) => {
      variants = appendVariantLink(variants, productVariant);
    });

    return {
      ...asset,
      products,
      productVariants: variants,
    };
  });

  if (!selectedAffectedCount) {
    return { ...state, items };
  }

  let aggregatedProducts = state.selectedAssetsAggregatedData?.products || [];
  let aggregatedVariants = state.selectedAssetsAggregatedData?.productVariants || [];

  if (product) {
    aggregatedProducts = appendProductLink(aggregatedProducts, product);
  }

  if (productVariants.length) {
    productVariants.forEach((productVariant) => {
      const idx = aggregatedVariants.findIndex(
        (link) => isSameVariantLink(link, productVariant),
      );

      if (idx > -1) {
        aggregatedVariants = aggregatedVariants.map((link, linkIdx) => (
          linkIdx === idx
            ? {
              ...link,
              numberOfAssets: (link.numberOfAssets || 1) + selectedAffectedCount,
            }
            : link
        ));
      } else {
        aggregatedVariants = [
          ...aggregatedVariants,
          { ...productVariant, numberOfAssets: selectedAffectedCount },
        ];
      }
    });
  }

  return {
    ...state,
    items,
    selectedAssetsAggregatedData: {
      ...state.selectedAssetsAggregatedData,
      products: aggregatedProducts,
      productVariants: aggregatedVariants,
    },
  };
};

export default applyAssetProductLinks;
